var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"button",style:(_vm.isFull ? 'width : 100%;' : ''),on:{"click":_vm.handleClick}},[_c('span',{staticClass:"icon"},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }